import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getThreadById } from "./schema/agents/get-thread-by-id";

export const rpcDefinition = { getThreadById };

export type AdminAgentsRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
